import { formatDate } from '@/api/common'
/**
 * 文件处理工具类
 */

/**
 * 点击触发文件下载
 * @param {String} src 下载链接
 * @param {String} name 下载文件名称,若不传则默认为下载链接名称
 */
export function download(src) {
  const downloadLink = document.createElement('a')
  downloadLink.target = '_blank'
  downloadLink.download = src
  downloadLink.href = src
  downloadLink.onclick = function(event) {
    document.body.removeChild(event.target)
  }
  downloadLink.style.visibility = 'hidden'
  document.body.appendChild(downloadLink)
  downloadLink.click()
}

/**
 * 点击触发文件下载,二进制方式
 * 该方法能够下载一些download打开无法默认下载的资源，例如一些跨域资源（跨域资源download属性不生效）
 * @param {String} url 下载文件地址
 * @param {String} filename 下载文件名称
 * @param {Function} callback 下载进度回调函数
 */
export function downloadBlob(url, filename, callback) {
  var xhr = new XMLHttpRequest()
  xhr.open('get', url)
  xhr.responseType = 'arraybuffer'
  // 进度条
  xhr.onprogress = event => {
    if (event.lengthComputable) {
      var loaded = parseInt((event.loaded / event.total) * 100)
      if (callback) {
        callback(loaded)
      }
    }
  }
  xhr.onload = function() {
    var link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([xhr.response]))
    link.download = filename ? filename : url

    link.click()
    link.remove()
  }
  xhr.send()
}
/**
 * 点击触发文件下载ZIP格式
 * @param {String} content 下载链接
 * @param {String} file_name 下载文件名称,若不传则默认为下载链接名称
 */
export function downloadZip(content, file_name) {
  const csvData = new Blob([content], { type: 'application/zip' })
  // for IE
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(csvData, file_name)
  }
  // for Non-IE (chrome, firefox etc.)
  else {
    let a = document.createElement('a')
    document.body.appendChild(a)
    a.style = 'display: none'
    const url = window.URL.createObjectURL(csvData)
    a.href = url
    a.download = file_name + formatDate(new Date(), 'yyyyMMddhhmmss')
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
  }
}
